// ============================================
// Profile - State (Zustand 기반)
// ============================================

import { useProfileStore } from '../../stores/profileStore.js';
import { useAuthStore } from '../../stores/authStore.js';

let profileDb = null;

export function getDb() {
  if (!profileDb) profileDb = firebase.firestore();
  return profileDb;
}

export function getProfileSelectorOptions() {
  return useProfileStore.getState().profileSelectorOptions;
}

export function setProfileSelectorOptions(options) {
  useProfileStore.getState().setProfileSelectorOptions(options);
}

export async function loadProfiles(forceRefresh = false) {
  const user = useAuthStore.getState().currentUser;
  if (!user) return useAuthStore.getState().cachedProfiles || [];

  const cached = useAuthStore.getState().cachedProfiles;
  if (!forceRefresh && cached && cached.length > 0) return cached;

  try {
    const db = getDb();
    const snapshot = await db.collection('users').doc(user.uid)
      .collection('profiles').orderBy('createdAt', 'desc').get();

    const profiles = [];
    snapshot.forEach(doc => {
      const data = doc.data();
      profiles.push({
        id: doc.id,
        name: data.name,
        gender: data.gender || '남성',
        birthDate: data.birthDate || null,
        birthCalendar: data.birthCalendar || '양력',
        birthTime: data.birthTime || '모름',
        createdAt: data.createdAt?.toDate?.()?.toISOString() || null
      });
    });

    useAuthStore.getState().setCachedProfiles(profiles);
    return profiles;
  } catch (e) {
    console.error('[Profile] loadProfiles error:', e);
    return useAuthStore.getState().cachedProfiles || [];
  }
}

export async function loadProfile(profileId) {
  const user = useAuthStore.getState().currentUser;
  if (!profileId || !user) return null;

  const cached = useAuthStore.getState().cachedProfiles || [];
  const found = cached.find(p => p.id === profileId);
  if (found) return found;

  try {
    const db = getDb();
    const doc = await db.collection('users').doc(user.uid)
      .collection('profiles').doc(profileId).get();

    if (!doc.exists) return null;

    const data = doc.data();
    return {
      id: doc.id,
      name: data.name,
      gender: data.gender || '남성',
      birthDate: data.birthDate || null,
      birthCalendar: data.birthCalendar || '양력',
      birthTime: data.birthTime || '모름',
      createdAt: data.createdAt?.toDate?.()?.toISOString() || null
    };
  } catch (e) {
    console.error('[Profile] loadProfile error:', e);
    return null;
  }
}
